import { init, track, Identify, setUserId, identify, getDeviceId } from "@amplitude/analytics-browser";
import { ICurrentUser } from "store/user/user-state";

const API_KEY = import.meta.env.REACT_APP_ENV === "production"
  ? import.meta.env.REACT_APP_AMPLITUDE_LIVE_KEY
  : import.meta.env.REACT_APP_AMPLITUDE_STAGING_KEY;

try {
  init(API_KEY, { defaultTracking: false });
} catch (e) {
  console.error(`Amplitude SDK initialization error: ${e}`);
}

/**
 * For naming conventions follow these rules:
 * https://help.amplitude.com/hc/en-us/articles/115000465251-Data-planning-playbook
 */
class AmpliAnalytics {
  identifyUser(user: ICurrentUser) {
    setUserId(user.username);

    const userIdentity = new Identify();
    userIdentity.set("Verified", user.verified);

    return identify(userIdentity).promise;
  }

  getDeviceId(): string | undefined {
    try {
      return getDeviceId();
    } catch (e) {
      console.error("Failed to get device id");
    }
  }

  sendForcedFullscreenEntered() {
    track("Forced Fullscreen Entered");
  }

  sendForcedFullscreenExitClicked() {
    track("Forced Fullscreen Exit Clicked");
  }

  sendUploadStarted() {
    track("Upload: Started");
  }

  sendUploadTagSelectionStarted() {
    track("Upload: Tag Selection Started");
  }

  sendUploadTagSelectionEnded(tagsNumber: number) {
    track("Upload: Tag Selection Ended", {
      "Tags Selected": tagsNumber
    });
  }

  sendUploadEnded() {
    track("Upload: Ended");
  }
}

export default new AmpliAnalytics();
